import type { ExactTheme } from "./theme.ts";

const dotGet = <Obj extends Record<string, any>>(
  obj: Obj,
  dotPath: DeepKeys<Obj>,
) => {
  const parts = dotPath.split(".");
  let res = undefined;
  while (parts.length !== 0) {
    const key = parts.shift()!;
    res = obj[key];
    obj = res;
  }

  return res;
};

type DropInitDot<T> = T extends `.${infer U}` ? U : T;
type FixArr<T> = T extends readonly any[]
  ? Omit<T, Exclude<keyof any[], number>>
  : T;

type _DeepKeys<T> = T extends object
  ? {
      [K in (string | number) & keyof T]: `${
        | `.${K}`
        | (`${K}` extends `${number}` ? `[${K}]` : never)}${
        | ""
        | _DeepKeys<FixArr<T[K]>>}`;
    }[(string | number) & keyof T]
  : never;
export type DeepKeys<T> = DropInitDot<_DeepKeys<FixArr<T>>>;

export const themeGet =
  (key: DeepKeys<ExactTheme>) => (props: { theme: ExactTheme }) => {
    return dotGet(props.theme, key);
  };
